





import React, { useEffect, useState } from 'react';
import styles from '../../../css/dashboard/News_event.module.css';
import { fetchNews_company_news } from '../../ApisService/apiService';
import ExpandableText from './ExpandableText';
import { useNavigate } from 'react-router-dom';

const Ipo_analysis_news = () => {
  const [newsData, setNewsData] = useState([]);
  const [loading, setLoading] = useState(true);
    const navigate = useNavigate();


  useEffect(() => {
    const getNews = async () => {
      try {
        const data = await fetchNews_company_news("IPO", "ANALYSIS"); 
        setNewsData(data);
      } catch (error) {
        console.error("❌ Error in Company_news:", error);
      } finally {
        setLoading(false);
      }
    };
  
    getNews();
  }, []);
  

  if (loading) return <p className={styles.loading}>📰 Loading today's headlines...</p>;

  return (
    <div className={styles.wrapper}>
       <button
          type="button"
          onClick={() => navigate(-1)}
          aria-label="Go back"
          style={{
            position: 'fixed', 
            background: 'transparent',
              backgroundColor: 'var(--gold)',
            border: 'none',
            borderRadius: '50%',
            width: '40px',
            height: '40px',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'transform 0.2s ease-in-out',
          }}
          onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
          onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1.0)'}
        >
          <i
            className="fa fa-arrow-left"
            aria-hidden="true"
            style={{
              fontSize: '22px',
              color: 'white',
            }}
          ></i>
        </button>
      <div className={styles.header}>
        <h1 className={styles.title}>🗞️ Stock Exploder Daily</h1>
        <p className={styles.subtitle}>Bringing you the latest updates from the stock world</p>
        <h3 className={styles.title}>IPO ANALYSIS</h3>  
      </div>

      {newsData.length === 0 ? (
        <p className={styles.noNews}>No news found today.</p>
      ) : (
        newsData.map((item, index) => {
          const json = item.json || {};
          return (
            <div key={index} className={styles.card}>
              <h2 className={styles.heading}>{json.HEADING}</h2>
              <p className={styles.meta}>
                <span>📅 {new Date(json.DATE).toLocaleDateString()} </span> | 
                <span> 🕘 {json.TIME} </span> | 
                <span> 🏢 {item.secname} → {item.subsecname} </span>
              </p>
              {json.CAPTION && <p className={styles.caption}><em>“{json.CAPTION}”</em></p>}
              {/* <div className={styles.details} dangerouslySetInnerHTML={{ __html: json.DETAILS }} /> */}
                  {/* ✅ This is the expandable content */}
                  <ExpandableText htmlContent={json.DETAILS} />
            </div>
          );
        })
      )}
    </div>
  );
};

export default Ipo_analysis_news;
